module.exports = __webpack_public_path__ + "img/62.3b580d48.jpg";